import { create } from 'zustand';

export const useCurrentSituationEvaluationStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    searchParams: {
        page: 1,
        pageSize: 20,
        sortBy: 'assetGroupName',
        sortOrder: 'asc',
        search: '',
    },
    paginationData: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 20,
    },
    scopeDialogOpen: false,
    scopeLoading: false,
    scopeSaving: false,
    scopeApplicabilityIds: [],
    scopeOptions: [],

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) => set((state) => ({
        searchParams: { ...state.searchParams, ...params },
    })),
    setPaginationData: (paginationData) => set({ paginationData }),
    openScopeDialog: () => set({ scopeDialogOpen: true }),
    closeScopeDialog: () => set({ scopeDialogOpen: false }),
    setScopeLoading: (scopeLoading) => set({ scopeLoading }),
    setScopeSaving: (scopeSaving) => set({ scopeSaving }),
    setScopeData: ({ applicabilityIds, options }) => set({
        scopeApplicabilityIds: applicabilityIds || [],
        scopeOptions: options || [],
    }),
    setScopeApplicabilityIds: (scopeApplicabilityIds) => set({ scopeApplicabilityIds }),
}));
